import { useCallback } from "react";
import { useCalendarConfiguration } from "../../context/CalendarRoot.js";
import { formatDate, parseDate } from "../../context/utils.js";
function useSelection(props) {
  const { selection, onChange } = props;
  const { dateFnsOptions } = useCalendarConfiguration();
  const selectionString = selection ? formatDate(selection, dateFnsOptions) : "";
  const handleOnClick = useCallback(
    (day, type) => {
      if (day) {
        const date = parseDate(day, dateFnsOptions);
        onChange?.(date, selection, type);
      }
    },
    [dateFnsOptions, onChange, selection]
  );
  return {
    handleOnClick,
    selectionString
  };
}
export {
  useSelection
};
//# sourceMappingURL=useSelection.js.map
